import React, { useCallback, useEffect, useMemo, useState } from "react";
import { SearchOutlined } from "@ant-design/icons";
import { useIntl } from "react-intl";
import { useHistory } from "react-router-dom";
import {
  Container,
  Title,
  SearchContainer,
  InputWrapper,
  IconWrapper,
  StyledInput,
} from "../style";
import { notification } from "antd";
import api from "../../../../service";
import { useSelector } from "react-redux";
import { TransferHistoryCustomTable } from "./styles";
import { Nav } from "../Sales/styles";
import GoBackButton from "../../components/goBackButton";
import { FantasyNameAndContractBadge } from "../../components/badges";

const StaffServiceTransferHistory = () => {
  const intl = useIntl();
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [transferHistory, setTransferHistory] = useState([]);
  const { token } = useSelector((state) => state.auth);
  const fantasyName = localStorage.getItem("serviceFantasyname");
  const serviceContractNumber = localStorage.getItem("serviceContractNumber");
  const opportunityId = localStorage.getItem("serviceOpportunityId");
  const systemUserId = localStorage.getItem("serviceSystemUserId");
  const serviceEventId = localStorage.getItem("serviceEventId");
  const [searchValue, setSearchValue] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const isPortuguese = useMemo(() => intl.locale === "pt", [intl]);
  const [paginationInfo, setPaginationInfo] = useState(null);

  useEffect(() => {
    fetchCredentialsHistory();
  }, [currentPage, pageSize, searchValue]);

  const fetchCredentialsHistory = useCallback(async () => {
    setLoading(true);
    const page = currentPage - 1;
    try {
      const response = await api.get(
        `/credential-transfer?page=${page}&per_page=${pageSize}&event_id=${serviceEventId}&opportunity_id=${opportunityId}&search=${searchValue}&system_user_id=${systemUserId}`,

        {
          headers: {
            "Content-Type": "application/json",
            Accept: "*/*",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setTransferHistory(response.data.credentialTransferOutputs);
      setPaginationInfo(response.data.paginationInfo);
    } catch (error) {
      notification.error({
        message: intl.formatMessage({
          id: "error",
        }),
        description: intl.formatMessage({
          id: "api.error." + error.response?.data?.description,
        }),
      });
    } finally {
      setLoading(false);
    }
  }, [
    currentPage,
    intl,
    opportunityId,
    pageSize,
    serviceEventId,
    systemUserId,
    token,
  ]);

  const normalize = (str) =>
    (str || "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase();

  const filteredData = transferHistory
    .filter((item) => {
      const search = normalize(searchValue);
      return (
        normalize(item.user).includes(search) ||
        normalize(item.category).includes(search) ||
        normalize(item.benefited).includes(search) ||
        new Date(item.transferDate).toLocaleDateString("pt-BR").includes(search)
      );
    })
    .map((item, index) => ({
      key: item.id ?? index,
      quant: item.quantity,
      date: new Date(item.transferDate).toLocaleDateString("pt-BR"),
      category: isPortuguese ? item.category : item.englishCategory,
      transferredBy: item.user,
      benefited: item.benefited,
    }));

  const columns = [
    {
      title: "Qtde.",
      dataIndex: "quant",
      key: "quant",
      width: "10%",
    },
    {
      title: intl.formatMessage({ id: "transferred_in" }),
      dataIndex: "date",
      key: "date",
      width: "15%",
    },
    {
      title: intl.formatMessage({ id: "category" }),
      dataIndex: "category",
      key: "category",
      width: "15%",
    },
    {
      title: intl.formatMessage({ id: "transferred_by" }),
      dataIndex: "transferredBy",
      key: "transferredBy",
      width: "30%",
    },
    {
      title: intl.formatMessage({ id: "benefited" }),
      dataIndex: "benefited",
      key: "benefited",
      width: "30%",
    },
  ];

  return (
    <Container>
      <Nav>
        <GoBackButton
          noPosition
          href={"/staff-access/service-panel"}
          intlId="backToDashboard"
        />

        <FantasyNameAndContractBadge
          fantasyname={fantasyName}
          contractNumber={serviceContractNumber}
        />
      </Nav>
      <Title>{intl.formatMessage({ id: "transfer-history" })}</Title>{" "}
      <SearchContainer style={{ marginBottom: "25px" }}>
        <InputWrapper>
          <IconWrapper>
            <SearchOutlined />
          </IconWrapper>
          <StyledInput
            style={{ paddingLeft: "30px" }}
            placeholder={intl.formatMessage({ id: "search" })}
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
          />
        </InputWrapper>
      </SearchContainer>
      <TransferHistoryCustomTable
        loading={loading}
        columns={columns}
        dataSource={filteredData}
        pagination={{
          current: paginationInfo?.pageNumber + 1 || 1,
          pageSize: paginationInfo?.maxSize || 10,
          total: paginationInfo?.totalElements || 0,
          showSizeChanger: true,
          pageSizeOptions: ["10", "15", "20", "25"],
          onChange: (page, pageSize) => {
            setCurrentPage(page);
            setPageSize(pageSize);
          },
          showTotal: (total, range) =>
            `${intl.formatMessage({ id: "displaying" })} ${range[0]}-${
              range[1]
            } ${intl.formatMessage({
              id: "of",
            })} ${total}`,
          locale: { items_per_page: "" },
          showLessItems: true,
          showQuickJumper: false,
        }}
      />
    </Container>
  );
};

export default StaffServiceTransferHistory;
